
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { IssueDetailModel, IssueFileModel, IssueModel } from 'src/app/shared/models/issue.model';
import { ProductModel } from 'src/app/shared/models/product.model';
import { IssueCategoryService } from 'src/app/shared/services/issue-category.service';
import { IssueService } from 'src/app/shared/services/issue.service';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-issue-detail-edit',
  templateUrl: './issue-detail-edit.component.html',
  styleUrls: ['./issue-detail-edit.component.css']
})
export class IssueDetailEditComponent implements OnInit {

  @Input() issue : IssueDetailModel;
  @Input() call : CallModel;
  @Input() files : IssueFileModel [];
  @Output() onChangeToDetail: EventEmitter<any> = new EventEmitter<any>();

  issue_category: string;
  product_category : string;

  isIssueProduct : boolean;
  isIssueEtc : boolean;
  isProductEtc : boolean;

  listIssueCategory : CategoryModel[];
  listProductCategory : CategoryModel[];

  listProduct : ProductModel[];

  form : FormGroup = IssueModel.getFormGroup();

  constructor(
    private service : IssueService,
    private icservice : IssueCategoryService,
    private pcservice : ProductCategoryService,
    private pservice : ProductService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router) {

    this.isIssueProduct = false;
    this.isIssueEtc = false;

    console.log("IssueDetailEditComponent : constructor");
  }

  ngOnInit() {

    this.icservice.getList().subscribe(
      res=>{
        this.listIssueCategory = res as CategoryModel[];
      },
      err=>{}
      );

      this.pcservice.getList().subscribe(
        res=>{
          this.listProductCategory = res as CategoryModel[];
        },
        err=>{}
      );

      this.pservice.getList().subscribe(
        res=>{
          this.listProduct = res as ProductModel[];
        },
        err=>{}
      );

        if(this.issue)
        {
           //this.populateForm(this.issue);
           IssueModel.populateFormFromDetailModel(this.form, this.issue);
        }
        else{
          //this.initializeFormGroup();
           IssueModel.initializeFormGroup(this.form);
        }
  }

  onCategoryChangeAction(data) {
   // var value = this.form.get('issueCategoryId').value;
   console.log("onCategoryChangeAction : " + data.source.selected.viewValue);
    this.isIssueProduct = (data.source.selected.viewValue == "Product");
   // this.isIssueEtc = (data == "*");

  }

  onProductChangeAction()
  {
    /*
    var value = this.form.get('productId').value;
    this.isProductEtc = (value == "*");
 */
  }

  onSave()
  {
    console.log("onSave : " + this.form.get('issue').value);

    if (this.files)
    {
        this.form.value.files = new Array<string>();
        for(var item of this.files)
        {
          this.form.value.files.push(item.fileId);
        }
    }

    if(!this.form.get('issueId').value) //insert
    {

       // this.service.insertData(data).subscribe(
        this.service.insertData(this.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "Issue Create");
            this.gnotify.showSnackBar('Issue Create', 'Submit successfuly', "success");
            var temp = res as IssueModel;
            if(this.call){
              this.call.callLog.issueId = temp.issueId;
              this.call.issue = temp;
            }
            this.onChangeToDetail.emit(res);
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Issue Create");
            this.gnotify.showSnackBar('Issue Create', 'Failed to Submit', "error");
          }
        );

        // this code should be called after service function ( this will delete files value from the form data)
        if(this.call && this.call.client && this.call.callLog)
        {
          this.form.controls['clientId'].setValue(this.call.client.clientId);
          this.form.controls['callId'].setValue(this.call.callLog.callId);
        }

    }
    else // update
    {
     // this.service.updateData(data).subscribe(
      this.service.updateData(this.form.value).subscribe(
        res=>{
          ////this.toastr.success("Update successfuly", "Issue Modify");
          this.gnotify.showSnackBar('Issue Modify', 'Update successfuly', "success");
          this.onChangeToDetail.emit(res);
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "Issue Modify");
          this.gnotify.showSnackBar('Issue Modify', 'Failed to Submit', "error");
        }
      );
    }

  }
  onBack()
  {
       this.onChangeToDetail.emit(false);
  }


  onDeleteFile(fileId)
  {
      if(!confirm("Are you sure to delete this image?")) return;
      this.files = this.files.filter(item => item.fileId != fileId);
  }

  public uploadFinished = (event) => {

    if(event)
    {
      if(!this.files) this.files = new Array<IssueFileModel>();
       this.files.push( IssueFileModel.convertFromUploadedFile(event));
    }

  }
}
